export default __webpack_public_path__ + "static/media/Jonathan Wilson.5fb59180.png";